import { resolveIdentityConfirmationError } from './resolve-identity-confirmation-error';

export function resolveInlineIdentityError(
    confirmIdentityError: unknown,
    changeEmailError: unknown,
): string | undefined {
    const fromConfirmIdentity = resolveIdentityConfirmationError(confirmIdentityError);
    if (fromConfirmIdentity && fromConfirmIdentity.surface !== 'toast') {
        return fromConfirmIdentity.message;
    }

    const fromChangeEmail = resolveIdentityConfirmationError(changeEmailError);
    if (fromChangeEmail && fromChangeEmail.surface !== 'toast') {
        return fromChangeEmail.message;
    }

    return undefined;
}
